<template>
  <div>
    <BreadCrumb PageTitle="Data Overview" />
    <div class="row">
      <div class="col-lg-4">
        <ProjectSummary :leadID="leadID" />
      </div>
      <div class="col-lg-8" v-if="mode == 'basecamp-search'">
        <BasecampSearchList :leadID="leadID" />
      </div>
      <div class="col-lg-8">
        <DataStreamList :leadID="leadID" />
      </div>
      <div class="col-lg-12" v-if="projectDetails != null && projectDetails.basecampProjectID != ''">
        <TaskList :BasecampProjectId="projectDetails.basecampProjectID" />
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent, ref, onMounted, watch, provide } from "vue";
import axios from "axios";
import { useRoute } from "vue-router";
import BreadCrumb from "../../components/Common/DynamicBreadCrumb.vue";
import ProjectSummary from "../../components/Projects/ProjectDetails/ProjectSummary.vue";
import DataStreamList from "../../components/ELSA/TableManagement/DataStreamList.vue";
import TaskList from "../../components/Task/TaskList.vue";
import BasecampSearchList from "../../components/Task/BasecampSearchList.vue";
import { BASE_HSUITE_URL } from '@/core/constant/env';

export default defineComponent({
  name: "LeadDetailsPage",
  components: {
    BreadCrumb,
    ProjectSummary,
    DataStreamList,
    TaskList,
    BasecampSearchList
  },
  setup() {
    const route = useRoute();
    const leadID = ref<number | null>(null);
      const mode = ref('');
    const projectDetails = ref({
      enquiryID: 0,
      clientName: '',
      status: '',
      salesman: '',
      businessArea: '',
      projectDescription: '',
      projectValue: 0,
      basecampProjectID: '',
    });

    const setMode = async (modeSetup: string) => {
       mode.value = modeSetup;
    }

    provide('setMode', setMode);

    const fetchProjectDetails = async (leadID: number) => {
      try {
        const response = await axios.get(`${BASE_HSUITE_URL}/api/Project/GetProjectByLeadID/${leadID}`);
        if (response.data.status === "Success") {
          projectDetails.value = {
            enquiryID: response.data.projectDetails.enquiryID,
            clientName: response.data.projectDetails.clientName,
            status: response.data.projectDetails.status,
            salesman: response.data.projectDetails.salesman,
            businessArea: response.data.projectDetails.businessArea,
            projectDescription: response.data.projectDetails.projectDescription,
            projectValue: response.data.projectDetails.projectValue,
            basecampProjectID: response.data.projectDetails.basecampProjectID
          };
        }
        console.log(projectDetails)
      } catch (error) {
        console.error("Error fetching project details:", error);
      }
    };

    onMounted(() => {
      const id = route.params.leadID;
      if (typeof id === "string") {
        leadID.value = parseInt(id, 10);
        console.log("Lead ID:", leadID.value);  // Debug log
      }

      if (leadID.value) {
        fetchProjectDetails(leadID.value);
      }
    });

    watch(() => leadID.value, (newLeadID) => {
      if (newLeadID) {
        fetchProjectDetails(newLeadID);
      }
    });

    return {
      leadID, projectDetails, mode
    };
  },
});
</script>
